<template>
<div>
    <el-dialog title="选择银行支行" width="60%" :visible.sync="viewData.visible" append-to-body>
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="queryHandle()" size="small">
            <el-form-item label="银行名称:">
                <el-input size="small" v-model="dataForm.bankName" placeholder="银行名称" clearable @blur="queryHandle"></el-input>
            </el-form-item>
            <el-form-item label="银行编码:">
                <el-input size="small" v-model="dataForm.bankCode" placeholder="银行编码" clearable @blur="queryHandle"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" @click="queryHandle()" icon="el-icon-search">查询</el-button>
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" bProject style="width: 100%; margin-bottom: 15px;" :default-expand-all="false"
            @current-change="currentChange" highlight-current-row border :header-cell-style="{background:'#f5f5f5'}">
                <el-table-column type="index" width="120" header-align="center" align="center" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="bankName" header-align="center" align="center" label="银行名称">
                </el-table-column>
                <el-table-column prop="bankCode" header-align="center" align="center" label="银行编码">
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]"
                :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" style="text-align: right" class="mb15 mt10">
            </el-pagination>
        </div> 
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="viewData.visible = false">
                取消
            </el-button>
            <el-button size="small" type="primary" @click="confirm()">
                确认
            </el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {
    DIALOG_CLOSED_TYPE
} from "@/utils/const";
import {
    fetchBankList
} from "@/controller/systemData";
import moment from "moment";
export default {
    data() {
        return {
            documentClientHeight: document.documentElement["clientHeight"] - 250,
            dataForm: {
                bankCode: "",
                bankName: "",
            },
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
            viewData: {
                visible: false,
                width: "",
            },
            userList: [],
            currentRow: {},
        };
    },
    mounted() {},
    activated() {
        this.getDataList();
    },
    methods: {
        // 查询条件变化
        queryHandle() {
            this.pageIndex = 1;
            this.getDataList();
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true;
            fetchBankList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                bankCode: this.dataForm.bankCode,
                bankName: this.dataForm.bankName,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.dataList = data.body.records;
                    this.totalPage = data.body.total;
                } else {
                    this.dataList = [];
                    this.totalPage = 0;
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false;
            });
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        currentChange(currentRow) {
            console.log(currentRow);
            this.currentRow = currentRow;
        },
        open() {
            this.viewData.visible = true;
            this.getDataList();
        },
        onClosed(params) {
            console.log(params);
            return;
        },
        // 筛选按钮弹框取消
        cancel() {
            this.close();
        },
        close(option = DIALOG_CLOSED_TYPE.CLOSE) {
            if (!this.viewData.visible) {
                return;
            }
            if (this.multiple) {
                this.onClosed({
                    option,
                    sender: this,
                    data: this.userList,
                });
            } else {
                this.onClosed({
                    option,
                    sender: this,
                    data: this.currentRow,
                });
            }
            this.viewData.visible = false;
        },
        confirm() {
            this.close(DIALOG_CLOSED_TYPE.CONFIRM);
        }
    },
};
</script>
